/* eslint-disable no-restricted-syntax */
const bodyElement = document.querySelector('body');
const allQuicklinks = document.querySelectorAll('[data-name]');
const allServicesLinks = [];
const serviceLinksContainerEl = document.querySelector('#quicklinksContainer');
const hasHotelContent = document.querySelector('#hotel-content');
const headerOffset = document.querySelector('#booking-header-search') && !hasHotelContent ? 240 : 160;

for (const quicklinksElem of allQuicklinks) {
	if (quicklinksElem.getAttribute('id') && quicklinksElem.getAttribute('data-name')) {
		allServicesLinks.push({
			id: quicklinksElem.getAttribute('id'),
			title: quicklinksElem.getAttribute('data-name'),
		});
	}
}

if (serviceLinksContainerEl && allServicesLinks.length > 0) {
	serviceLinksContainerEl.innerHTML = '';

	for (const serviceItem of allServicesLinks) {
		const serviceLinkEl = document.createElement('a');
		serviceLinkEl.classList.add('quick-link-text');
		serviceLinkEl.href = `${document.URL}#${serviceItem.id}`;
		serviceLinkEl.title = serviceItem.title;
		serviceLinkEl.innerHTML = serviceItem.title;
		serviceLinkEl.setAttribute('data-target', serviceItem.id);

		serviceLinkEl.addEventListener('click', function (eve) {
			eve.preventDefault();
			eve.stopPropagation();
			const targetEl = document.querySelector(`#${eve.target.getAttribute('data-target')}`);
			const elementPosition = hasHotelContent?.contains(targetEl) ? targetEl.getBoundingClientRect().top + window.scrollY : targetEl.offsetTop;
			const offsetPosition = elementPosition - headerOffset;

			window.scroll(0, offsetPosition, { behavior: 'smooth' });
		});

		const serviceLinkListItemEl = document.createElement('li');
		serviceLinkListItemEl.appendChild(serviceLinkEl);

		serviceLinksContainerEl.appendChild(serviceLinkListItemEl);
	}
}

const serviceLinksOuterEl = document.querySelector('#quicklinksOuter:not(.js-disable-sticky-scroll)');
if (serviceLinksOuterEl) {
	document.querySelector('html').classList.add('scroll-smooth');
	const headerSearchEl = document.querySelector('#booking-header-search');
	const bookingHotelWidgetEl = document.querySelector('#hotel-content #booking-hotels-booking-widget');
	const serviceLinksOuterOffsetTop = serviceLinksOuterEl.getBoundingClientRect().top + window.scrollY - 100;
	const mediaBreakPoint = '(min-width: 768px)';
	const mq = window.matchMedia(mediaBreakPoint);
	const categoryParam = new URLSearchParams(window.location.search)?.get('category');
	const bookingCategories = ['holidays', 'flights', 'hotels', 'car-hire', 'motorhome-hire'];

	const scrollStickyServiceLinks = () => {
		const scrollPosY = window.pageYOffset || document.documentElement.scrollTop;

		// eslint-disable-next-line no-shadow
		const removeScrolling = function (mq) {
			if (mq.matches) {
				if (scrollPosY > serviceLinksOuterOffsetTop && !serviceLinksOuterEl.classList.contains('scrolling')) {
					serviceLinksOuterEl.classList.add('scrolling');
					if (bookingHotelWidgetEl) {
						bookingHotelWidgetEl.classList.add('scrolling');
					}
					bodyElement.classList.add('scrolling');

					// add extra spacing if the header widget is expanded
					if (headerSearchEl && bookingCategories.includes(categoryParam)) {
						serviceLinksOuterEl.classList.add('header-booking-widget-expanded');
					}
				} else if (scrollPosY <= serviceLinksOuterOffsetTop && serviceLinksOuterEl.classList.contains('scrolling')) {
					serviceLinksOuterEl.classList.remove('scrolling');
					serviceLinksOuterEl.classList.remove('header-widget-expanded');
					if (bookingHotelWidgetEl) {
						bookingHotelWidgetEl.classList.remove('scrolling');
					}
					bodyElement.classList.remove('scrolling');

					if (serviceLinksOuterEl.classList.contains('header-booking-widget-expanded')) {
						serviceLinksOuterEl.classList.remove('header-booking-widget-expanded');
					}
				}
			} else if (!mq.matches) {
				if (serviceLinksOuterEl.classList.contains('scrolling')) {
					serviceLinksOuterEl.classList.remove('scrolling');
					if (bookingHotelWidgetEl) {
						bookingHotelWidgetEl.classList.remove('scrolling');
					}
					bodyElement.classList.remove('scrolling');

					if (serviceLinksOuterEl.classList.contains('header-booking-widget-expanded')) {
						serviceLinksOuterEl.classList.remove('header-booking-widget-expanded');
					}
				}
			}
		};

		mq.addListener(removeScrolling);
		removeScrolling(mq);
	};

	scrollStickyServiceLinks();

	window.addEventListener(
		'scroll',
		function () {
			scrollStickyServiceLinks();
		},
		false
	);
}

const simpleQuickLinksOuterEls = document.querySelectorAll('.simple-quick-links-outer');
for (const simpleQuickLinksOuterElem of simpleQuickLinksOuterEls) {
	const simpleQuickLinksContainer = simpleQuickLinksOuterElem.querySelector('.simple-quick-links-container');
	const simpleQuickLinksItems = simpleQuickLinksContainer.querySelectorAll('.simple-quick-link-item');

	for (const simpleQuickLinksItem of simpleQuickLinksItems) {
		simpleQuickLinksItem.addEventListener('click', function (eve) {
			const href = eve.currentTarget.getAttribute('href');
			const hashTag = href.split('#')[1];
			const targetEl = document.querySelector(`#${hashTag}`);
			if (href.includes('#') && hashTag && targetEl) {
				eve.preventDefault();
				eve.stopPropagation();
				const elementPosition = targetEl.offsetTop;
				const offsetPosition = elementPosition - headerOffset;
				window.scroll(0, offsetPosition, { behavior: 'smooth' });
			}
		});
	}
}
